import * as firebase from 'firebase';

const prodConfig = {
	apiKey: "AIzaSyCDoIo-AWwIpMSpqG5Ggp4QGcM-sp8BH-I",
    authDomain: "sunlit-plasma-106309.firebaseapp.com",
    databaseURL: "https://sunlit-plasma-106309.firebaseio.com",
    projectId: "sunlit-plasma-106309",
    storageBucket: "sunlit-plasma-106309.appspot.com",
    messagingSenderId: "63848621192"
};

const devConfig = {
	apiKey: "AIzaSyCDoIo-AWwIpMSpqG5Ggp4QGcM-sp8BH-I",
    authDomain: "sunlit-plasma-106309.firebaseapp.com",
    databaseURL: "https://sunlit-plasma-106309.firebaseio.com",
    projectId: "sunlit-plasma-106309",
    storageBucket: "sunlit-plasma-106309.appspot.com",
    messagingSenderId: "63848621192"
};

// const devConfig = {
// 	apiKey: "AIzaSyC8SrqoYY0MmNfx8uorG_U29x9j-Bne-dA",
// 	authDomain: "dropcard-test.firebaseapp.com",
// 	databaseURL: "https://dropcard-test.firebaseio.com",
// 	projectId: "dropcard-test.appspot.com",
// 	storageBucket: 'dropcard-test.appspot.com',
// 	messagingSenderId: "91242506625",
// };

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

if (!firebase.apps.length) {
	firebase.initializeApp(config);
	console.log(process.env.NODE_ENV);
}

const db = firebase.database();
const auth = firebase.auth();
const storage = firebase.storage();

export {
	db,
	auth,
	storage,
};



// WEBPACK FOOTER //
// ./src/firedb/firebase.js